import { useLocation } from 'react-router';
import { useEffect } from 'react';

export function useSyncActiveModule() {
  const { pathname } = useLocation();

  useEffect(() => {
    const moduleKey = pathname.split('/').filter(Boolean)[0];

    if (['nnc', 'ooe'].includes(moduleKey)) {
      sessionStorage.setItem('activeModule', moduleKey);
    } else if (pathname.startsWith('/modules')) {
      sessionStorage.removeItem('activeModule');
    }
  }, [pathname]);
}
